import { Heart, Play, Star } from "lucide-react";

export default function PosterCard({ title, image, rating, sub, fav, onClick, onFav, testId, progress = 0 }) {
  return (
    <div className="group relative" data-testid={testId}>
      <button
        onClick={onClick}
        className="block w-full text-left rounded-xl overflow-hidden border border-[#212738] bg-[#11141F] transition-[transform,border-color] duration-200 hover:scale-[1.03] hover:border-[#E50914]/60 focus-visible:ring-2 focus-visible:ring-[#00E5FF] outline-none"
        data-testid={`${testId}-open`}
      >
        <div className="aspect-[2/3] bg-[#1A1E2E] relative">
          {image && <img src={image} alt="" loading="lazy" className="w-full h-full object-cover" onError={(e) => (e.currentTarget.style.display = "none")} />}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/10 to-transparent opacity-80" />
          <div className="absolute inset-0 grid place-items-center opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="w-12 h-12 rounded-full bg-[#E50914] grid place-items-center shadow-[0_0_30px_rgba(229,9,20,0.6)]">
              <Play className="w-5 h-5 fill-white text-white ml-0.5" />
            </span>
          </div>
          {rating && Number(rating) > 0 && (
            <span className="absolute top-2 left-2 flex items-center gap-1 rounded-md bg-black/70 px-1.5 py-0.5 text-[11px] font-mono text-[#FFB800]">
              <Star className="w-3 h-3 fill-current" /> {Number(rating).toFixed(1)}
            </span>
          )}
          <div className="absolute bottom-0 inset-x-0 p-3">
            <div className="text-sm font-medium leading-snug line-clamp-2">{title}</div>
            {sub && <div className="text-[11px] text-slate-400 mt-0.5 truncate">{sub}</div>}
          </div>
          {progress > 0 && (
            <div className="absolute bottom-0 inset-x-0 h-1 bg-white/10" data-testid={`${testId}-progress`}>
              <div className="h-full bg-[#E50914]" style={{ width: `${progress * 100}%` }} />
            </div>
          )}
        </div>
      </button>
      {onFav && (
        <button
          onClick={onFav}
          className={`absolute top-2 right-2 p-1.5 rounded-full bg-black/60 transition-opacity ${fav ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`}
          data-testid={`${testId}-fav`}
        >
          <Heart className={`w-4 h-4 ${fav ? "fill-[#E50914] text-[#E50914]" : "text-white"}`} />
        </button>
      )}
    </div>
  );
}
